__turbopack_context__.v({
  "root": "TextOpacityOnScrollSection-module__Exbfbq__root",
  "stickyWrapper": "TextOpacityOnScrollSection-module__Exbfbq__stickyWrapper",
});
